export type PaletteColors =
  | '#A8C9E0'
  | '#14A0FF'
  | '#daf0fe'
  | '#FFBF09'
  | '#535AF1'
  | '#041F4E'
  | '#524E65'
  | '#DAE0EB'
  | '#F1F7FC'
  | '#feeae3'
  | '#3E988D'
  | '#E9EDF3'
  | '#FFFFFF'
  | '#B6C2D8'
  | '#1d1d1d'
  | '#06CD81'
  | '#E65E59'
  | '#a1413e'
  | '#989cf7'
  | '#EDEEFE'
  | '#FFD8C7'
  | '#FBFF00'
  | '#c84bfc'
  | '#04b961'
  | '#e659a9'
  | '#edeefe'
  | '#fceef6'
  | '#e5f8ef'
  | '#FFEBE3'
  | '#04a467'
  | '#368d82'
  | '#FFF6d9'
  | '#A5EFBE'
  | '#E6E8EB'
  // Neutral
  // 90
  | '#051633'
  // Yellow
  | '#CF9B07' // 700
  | 'rgba(255, 191, 9, 0.15)' // 200
  | '#C6A538'

  // Red
  | '#DC2626'

  // Orange
  | '#FF7B43' // 700
  | 'rgba(255, 123, 67, 0.15)' // 500

  // Success
  | 'rgba(5, 150, 105, 1)' // 60
  | '#059669' // 500
  | 'rgba(3, 96, 67, 0.15)' // 200

  // Primary
  | '#2F39EE' // 900
  | '#535AF1' // 700
  | '#7B81F4' // 500
  | 'rgba(83, 90, 241, 0.15)' // 200

  // Secondary
  | '#1080CC' // 700
  | 'rgba(20, 160, 255, 0.15)' // 200
  | 'rgb(165,195,239)'
  | 'rgb(255,217,65)'
  | 'rgb(239,165,223)'
  | 'rgb(239,244,255)';

export type Palette = Record<string, PaletteColors>;

export const palette: Palette = {
  Iceberg_blue: '#A8C9E0',
  Secondary_blue: '#14A0FF',
  Sky_blue: '#daf0fe',
  Light_blue: '#989cf7',
  Mango_yellow: '#FFBF09',
  Duckling_yellow: '#FBFF00',
  Primary_blue: '#535AF1',
  Dark_blue: '#041F4E',
  Dark_gray: '#524E65',
  Outline_blue: '#DAE0EB',
  Background_blue: '#F1F7FC',
  Background_purple: '#EDEEFE',
  Orange_crayola: '#FF7B43',
  Light_orange: '#feeae3',
  Orange_crayola_light: '#FFD8C7',
  Orange_crayola_lighter: '#FFEBE3',
  Light_yellow: '#FFF6d9',
  Pine_green: '#3E988D',
  Emerald_green: '#06CD81',
  Emerald_green_darker: '#04a467',
  pastel_green: '#A5EFBE',
  Red: '#E65E59',
  Dark_Red: '#a1413e',
  Purple: '#c84bfc',
  Bright_green: '#04b961',
  Dark_pink: '#e659a9',
  Pale_blue: '#edeefe',
  Pale_green: '#e5f8ef',
  Pale_pink: '#fceef6',
  Dark_green: '#368d82',

  // These are not named colors in the design, but we encountered them.
  lightGrey1: '#E9EDF3',
  lightGrey: '#E6E8EB',
  white: '#FFFFFF',
  dim: '#B6C2D8',
  black: '#1d1d1d', // this is exclusively used by storybook.

  // Primary Colors
  primary_90: '#2F39EE',
  primary_70: '#535AF1',
  primary_700: '#535AF1',
  primary_50: '#7B81F4',
  primary_500: '#7B81F4',
  primary_20: 'rgba(83, 90, 241, 0.15)',
  primary_200: 'rgba(83, 90, 241, 0.15)',

  secondary_700: '#1080CC',
  secondary_200: 'rgba(20, 160, 255, 0.15)',

  orange_700: '#FF7B43',
  orange_200: 'rgba(255, 123, 67, 0.15)',

  yellow_700: '#CF9B07',
  yellow_200: 'rgba(255, 191, 9, 0.15)',

  success_60: 'rgba(5, 150, 105, 1)',
  success_500: '#059669',
  success_200: 'rgba(3, 96, 67, 0.15)',

  // Neutral Colors
  neutral_90: '#051633',

  /** Meal Type Colors */
  Breakfast: '#C6A538',
  Lunch: '#FF7B43',
  Dinner: '#DC2626',
  Snack: '#14A0FF',

  /* sticky note color*/
  stickyGreen: '#A5EFBE',
  stickyBlue: 'rgb(165,195,239)',
  stickyYellow: 'rgb(255,217,65)',
  stickyPink: 'rgb(239,165,223)',
  stickyLight: 'rgb(239,244,255)',
};
